module.exports = __webpack_public_path__ + "static/wyciag-z-konta-1751c8bf1fad2a30eba435be7ad9484a.jpg";